// extracted by mini-css-extract-plugin
module.exports = {"snowflake":"snowflake_snowflake__j3QzK","fall":"snowflake_fall__pQOQt"};